







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import btsmsConfig from '../../btsms/btsmsConfig.vue';
import govuknotifysmsConfig from '../../govuknotifysms/govuknotifysmsConfig.vue';
import messengerConfig from '../../messenger/messengerConfig.vue';
import twitterConfig from '../../twitter/twitterConfig.vue';
import googlebmConfig from '../../googlebm/googlebmConfig.vue';
import Toast from '@/shared/services/toast';
import { PublishedApp } from '../models';
import { GET_CHANNEL_IDENTITIES } from '@/store/channel-identities/actionTypes';

@Component({
	components: {
		LoadingSpinner,
		btsmsConfig,
		govuknotifysmsConfig,
		messengerConfig,
		twitterConfig,
		googlebmConfig
	}
})
export default class AppConfig extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Action(GET_CHANNEL_IDENTITIES) public loadChannelIdentities: any;

	public isLoading: boolean = true;

	public getComponentName() {
		if (this.currentApp.id === 'instagram') {
			return 'messengerConfig';
		}

		return `${this.currentApp.id.replaceAll('-', '')}Config`;
	}

	public async configSaved(stopRedirect: boolean) {
		await this.loadChannelIdentities(true);
		if (!stopRedirect) {
			// go back to appstore
			this.$router.push({name: 'apps'});
		}
		Toast.showSuccess('App setup completed');
	}

	public loaded() {
		this.isLoading = false;
	}
}
